/** @format */

import COLORS from './colors';

const OPL_STYLE = {
    FONT_COLOR: {
        PRIMARY: COLORS.MAIN.DARK,
        SECONDARY: COLORS.MAIN.LIGHT,
    },
    FONT: {
        PRIMARY: COLORS.MAIN.LIGHT,
        COLOR: COLORS.MAIN.PRIMARY,
    },
    BACKGROUND: {
        PRIMARY: COLORS.MAIN.DARK,
        SECONDARY: COLORS.MAIN.LIGHT,
        TERTIARY: COLORS.DARK_FUNCTION.FUNCTION_6,
    },
    BORDER: COLORS.DARK_FUNCTION.FUNCTION_4,
    TABLE: {
        ACTIVE_ROW: COLORS.DARK_FUNCTION.FUNCTION_5,
    },
};

export default OPL_STYLE;
